import OverlayWindow from 'Components/OverlayWindow';
import { useDayzed } from 'dayzed';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { DatePickerContext } from './context';
import DayPicker from './DayPicker';
import PickerHeader from './PickerHeader';

export function SingleDatePicker({
  value,
  onChange,
  minDate,
  maxDate,
  hourOffset = 'min',
}: {
  value?: Date;
  onChange: (d: Date) => void;
  minDate?: Date;
  hourOffset?: 'min' | 'max';
  maxDate?: Date;
}) {
  const [date, setDate] = useState<Date | undefined>();
  const dayzedData = useDayzed({
    selected: value,
    date,
    minDate,
    maxDate,
    showOutsideDays: true,
    onDateSelected: (d) => {
      let date = d.date;
      if (hourOffset === 'max') date.setHours(23, 59, 59);
      onChange(date);
      setDate(date);
    },
  });
  useEffect(() => {
    if (value) {
      setDate(value);
    }
  }, [value]);

  const { calendars } = dayzedData;

  if (!calendars.length) return <></>;

  const calendar = calendars[0];

  return (
    <DatePickerContext.Provider value={{ ...dayzedData }}>
      <OverlayWindow
        paddingSize=""
        size=""
        border="border border-gray-light"
        rounded="rounded"
      >
        <PickerHeader
          calendar={calendar}
          onDateChange={setDate}
          date={date}
          minDate={minDate}
          maxDate={maxDate}
        />
        <DayPicker calendar={calendar} onDateChange={setDate} date={date} />
      </OverlayWindow>
    </DatePickerContext.Provider>
  );
}
